import $ from 'jquery';

$(document).ready(function() {
    $('.js-game-puzzle-full').on('click', function() {
        if ($('.b-game-puzzle__full-img').hasClass('show')) {
        	$(this).html('Посмотреть изображение целиком');
        } else {
        	$(this).html('Вернуться к игре');
        }
        $('.b-game-puzzle__full-img').toggleClass('show');
    });
});


// WEBPACK FOOTER //
// ./src/js/pages/game-puzzle/game-puzzle-full.js